import { reqHome,reqSlider } from '@/api'

const state = {
    homeData:[],
    slideData:[]
}

const getters = {
    videoData(state){
        return state.homeData[0]  || {}
    },
    recommendProducts(state){
        return state.homeData[1]  || {}
    },
    solvementData(state){
        return state.homeData[2] || {}
    },
    businessData(state){
        return state.homeData[3] || {}
    },
    industrialData(state){
        return state.homeData[4] || {}
    },
    newsData(state){
        return state.homeData[5] || {}
    },
    slider(state){
        return state.slideData || []
    }
}

const mutations = {
    GETHOME(state,value){
        state.homeData = value
        // console.log("mutations接收数据");
    },
    GETSLIDER(state,value){
        state.slideData = value
    },
}

const actions = {
    async getHome({ commit }) {
        let res = await reqHome()
        if (res.code == 200) {
            // console.log("home仓库actions发请求");
            commit('GETHOME', res.content.content)
        }
    },
    async getSlider({ commit }) {
        let res = await reqSlider()
        if (res.code == 200) {
            commit('GETSLIDER', res.content)
        }
    }
}

export default {
    // namespaced: true,
    state,
    mutations,
    actions,
    getters
}